<template>
  <header class="l-header">
      <div class="l-header--logo relative">
        <a href="https://loveyou.ccf.org.tw/">
          <img src="~@/assets/logo.png" alt="">
        </a>
      </div>
      <div class="l-header--link relative">
        <ul class="flex">
          <li><a href="https://loveyou.ccf.org.tw/child-protection">兒童保護是什麼</a></li>
          <li><a href="https://loveyou.ccf.org.tw/data-status">現在兒童</a></li>
          <li><a href="https://loveyou.ccf.org.tw/about">關於家扶</a></li>
          <li><a href="https://loveyou.ccf.org.tw/protect-action">守護行動</a></li>
          <li><a href="https://loveyou.ccf.org.tw/neighbor">兒保好鄰居</a></li>
          <li><a href="https://loveyou.ccf.org.tw/dreamhome">我夢想的家</a></li>
          <li><a href="https://loveyou.ccf.org.tw/ebook">數位教材</a></li>
          <li><a href="https://loveyou.ccf.org.tw/game">兒保小測驗</a></li>
          <li><a href="https://loveyou.ccf.org.tw/forest-adventure/">森林探險</a></li>
        </ul>
      </div>
      <div class="l-header--hamburger">
        <div id="hbg" class="hamburger-box js-menu-trigger" ref="menuTrigger" @click="clickMenu">
          <div id="burger">
              <span class="line bg-gray"></span>
              <span class="line bg-gray"></span>
              <span class="line bg-gray"></span>
          </div>
        </div>
      </div>
      <div class="l-header--user">
        <ul class="flex">
          <li><a href="https://loveyou.ccf.org.tw/member/signup">註冊</a></li>
          <li><a href="https://loveyou.ccf.org.tw/member/login">登入</a></li>
          </ul>
      </div>
      <div class="l-header--menu js-menu-content" ref="menuContent">
        <div class="l-header--menu__body">
            <div class="navigation">
                <div class="menu">
                  <ul class="center">
                    <li><a href="https://loveyou.ccf.org.tw/child-protection">兒童保護是什麼</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/data-status">現在兒童</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/about">關於家扶</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/protect-action">守護行動</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/neighbor">兒保好鄰居</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/dreamhome">我夢想的家</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/ebook">數位教材</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/game">兒保小測驗</a></li>
                    <li><a href="https://loveyou.ccf.org.tw/forest-adventure/">森林探險</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
  </header>
</template>

<script>
import Menu from './js/Menu'

export default {
  name: 'Header',
  data () {
    return {
      menu: null
    }
  },
  methods: {
    clickMenu () {
      this.menu.toggle()
    }
  },
  mounted () {
    this.menu = new Menu()
  }
}
</script>

<style lang="scss" scoped>
.l-header {
    background: $white;
    position: absolute;
    top: 0;
    left: 0;
    height: map-get($headerHeight, xs);
    width: 100%;
    transition: 0.5s;
    padding: 20px;
    z-index: 100;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    &:after{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: $white;
      z-index: 9;
    }
    &--logo {
        z-index: 11;
        width: 200px;
    }
    &--hamburger {
        position: absolute;
        bottom: 0;
        right: 20px;
        height: 60px;
        width: 60px;
        z-index: 10;
        cursor: pointer;
           > div {
                height: 30px;
                width: 30px;
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
                margin: auto;
                .line {
                    display: block;
                    width: 30px;
                    height: 2px;
                    margin: 7px auto;
                    border-radius: 30px;
                    transition: 0.3s ease-in-out;
                }
            }
            &._active {
               > div {
                    .line:nth-child(1) {
                        transform: translate3d(0, 8px, 0) rotate(45deg);
                    }

                    .line:nth-child(2) {
                        opacity: 0;
                    }

                    .line:nth-child(3) {
                        transform: translate3d(-4px, -18px, 0) rotate(-45deg);
                    }
                }
            }
    }
    &--menu {
        position: fixed;
        top: 0;
        left: 0;
        height: calc(100% - 50px);
        width: 100%;
        pointer-events: none;
        z-index: 3;
        overflow: hidden;
        &:before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: rgba(#000, 0.9);
            z-index: -1;
            pointer-events: none;
            opacity: 0;
            transition: 0.3s map-get($ease, 'IOquad');
        }
        &__body {
            position: fixed;
            top: 0;
            right: 0;
            height: calc(100% - 50px);
            width: 100%;
            transform: translate3d(0, -100%, 0);
            transition: 0.6s 0.3s map-get($ease, 'IOquad');
            z-index: 0;
            padding-top: 100px;
            &:before{
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                height: 100%;
                width: 100%;
                background: $white;
            }
            ul{
              li{
                padding: 7.5px 0;
                color: #555555;
              }
            }
        }
        .navigation {
            position: relative;
            z-index: 1;
            overflow-y: scroll;
            overflow-x: hidden;
            height: 100%;
            margin: 40px 0 60px;
            padding: 0 20px 60px;
            .menu {
                position: relative;
                width: 100%;
            }
        }
        &._leaving {
            .navigation {
                .menu {
                    .menu-list--title,
                    .menu-list--item > li {
                        transition: 0.3s map-get($ease, 'IOquad');
                    }
                }
            }
        }
        &._active {
            pointer-events: visible;
            &:before {
                opacity: 1;
            }
            .l-header--menu__body {
                transform: translate3d(0, 0, 0);
            }
        }
    }
    &--link{
        display: none;
    }
    &--user{
        position: absolute;
        top: 60px;
        left: 0;
        width: 100%;
        height: 40px;
        background: #ffaeae;
        z-index: 11;
        ul{
            height: 100%;
            align-items: center;
            justify-content: center;
        }
        li{
            padding: 2.5px 10px;
            color: $white;
        }
    }
    @include respond-to(sm) {
        padding: 10px 0;
        &--hamburger {
            padding-left: 20px;
        }
    }
    @include respond-to(md) {
        &--hamburger {
            .hamburger-box {
                &:hover {
                    #burger {
                        .line:nth-child(1) {
                            transform: translate3d(0, 4px, 0);
                        }

                        .line:nth-child(2) {
                            opacity: 0;
                        }

                        .line:nth-child(3) {
                            transform: translate3d(0, -4px, 0);
                        }
                    }
                }
            }
        }
        &--link{
            a{
                transition: .4s;
                &:hover{
                    color: #f57773;
                }
            }
        }
    }
    @include respond-to('1200') {
        justify-content: space-between;
        height: map-get($headerHeight, md);
        &--menu,
        &--hamburger {
            display: none;
        }
        &--logo {
            margin-left: 20px;
        }
        &--link{
            display: block;
            z-index: 10;
            ul {
                padding: 0 20px;
            }
            li {
                padding: 0 10px;
            }
            a{
                font-size: 16px;
                color: #555555;
            }
        }
        &--user{
            width: 165px;
            border-radius: 20px;
            left: auto;
            bottom: auto;
            right: 40px;
            top: 10px;
            a{
                font-size: 16px;
            }
        }
    }
    @include respond-to(lg) {
        &--logo {
            margin-left: 20px;
        }
        &--link{
            li {
                padding: 0 20px;
            }
        }
    }
}

</style>
